import vandamme_win from "url:/src/img/vandamme_win.png";
import vandamme_loose from "url:/src/img/vandamme_loose.png";
import scoreSFXURL from "url:/src/sounds/coin.wav";
import {gsap} from "gsap";

const trad = {
    fr:{
        h3_win: "Bien joué l'artiste",
        p_win: "Tu nous as impressionés fils",
        h3_loose: "IE t'as explosé dans les mains",
        p_loose: "C'est ça aussi la vie d'une agence",
        damage: "Dégats",
        time: "Temps",
        total: "Score total",
        send: "Partage nous ton score",
        tryagain: "Recommencer"
    }
}

export default function({win, score, time}){
    const lang = document.getElementById("game").getAttribute("data-lang");
    const c = trad[lang];

    let fscore = score;
    if(win){
        let tratio = 1 - (time/(3 * 60 + 27));
        fscore += Math.floor(tratio * 5000);
    } 

    let result =  {
        win: win,
        score: fscore,
        time: formatTime(time),
    }
    const base64 = encodeURI(btoa(JSON.stringify(result)));
    const contact_url = document.getElementById("game").getAttribute("data-contact") + "?game=" + base64;

    const gameover = document.createElement("div");
    gameover.classList.add("gameover");
    if(!win) gameover.classList.add("gameover--lose");

    gameover.innerHTML =
    `<div class="gameover__header">
        <h3>${win ? c.h3_win : c.h3_loose}</h3>
        <div class="gameover__header__line"></div>
        <p>${win ? c.p_win : c.p_loose}</p>
        <img src="${win ? vandamme_win : vandamme_loose}">
    </div>
    <div class="scoreboard">
        <div class="scoreboard__score">
            <span>${c.damage}</span><span>${score}</span>
        </div>
        <div class="scoreboard__score scoreboard__score--time">
            <span>${c.time}</span><span>${formatTime(time)}</span>
        </div>
        <div class="scoreboard__score">
            <span>${c.total}</span><span>${fscore}</span>
        </div>
        <!--<a class="scoreboard__send" href="${contact_url}">${c.send}</a>-->
        <button id="scoreboard__tryagain" class="scoreboard__tryagain">${c.tryagain}</button>
    </div>`;

    document.getElementById("game").append(gameover);
    const tl = gsap.timeline();
    tl.delay(win ? 3 : 1);
    tl.from(".gameover__header img", {duration: .3, opacity: 0, scale: 0.8});
    tl.from(".gameover__header h3, .gameover__header .gameover__header__line, .gameover__header p", {duration: .3, y: 20, opacity: 0 });
    tl.from(".scoreboard__score", { delay: 0.5, duration: .3, opacity: 0, scale: 0.8, stagger: {
        each: 0.5,
        onStart: playsound
    }, ease: "back.out(1.7)"});
    tl.from(".scoreboard__send, .scoreboard__tryagain", { delay: 0.5, duration: 1.5, opacity: 0 });

    document.getElementById("scoreboard__tryagain").onclick = function(){
        document.location.reload();
    }
}

function playsound(){
    const sfx = new Audio(scoreSFXURL);
    sfx.volume = 0.1;
    sfx.play();
}

function formatTime(time){
    let min = Math.floor(time / 60);
    let sec = Math.floor(time % 60);
    if(sec < 10) sec = "0" + sec;
    return min + ":" + sec;
}